'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.updateView = undefined;

var _reduxActions = require('redux-actions');

var _actionTypes = require('../constants/actionTypes');

var updateView = exports.updateView = (0, _reduxActions.createAction)(_actionTypes.UPDATE_VIEW, function (view) {
  return { view: view };
});


//////////////////
// WEBPACK FOOTER
// ./js/current-view/actions/updateView.js
// module id = 293
// module chunks = 2 3